import './App.css';
import React, { useEffect, useState, Suspense } from 'react';
import MenuJS from './Components/MenuJS';
import { BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from './Components/ScrollToTop';

const Main = React.lazy(() => import('./Main'));

function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
}

function App() {
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const onScroll = debounce(() => {
      setLastScrollY(window.scrollY);
    }, 100);

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <MenuJS />

      <Suspense
        fallback={
          <div className="preload-wrapper">
            <div className="lds-spinner">
              <div></div><div></div><div></div><div></div>
              <div></div><div></div><div></div><div></div>
              <div></div><div></div><div></div><div></div>
            </div>
          </div>
        }
      >
        <Main />
      </Suspense>
    </Router>
  );
}

export default App;
